import { MutationTree } from 'vuex';
import { ClaimsState } from './types';

export const mutations: MutationTree<ClaimsState> = {
    setData(state, payload: any) {
        state.data = payload;
        state.loading = false;
    },
    setError(state, error) {
        state.error = true;
        state.data = undefined;
        state.loading = false;
    },
    setLoading(state) {
        state.loading = true;
    },
};
